import { SolutionsCardProps } from "@/components/screen/global-components/solutions/SolutionsCard";

const industriesSolutionsContent = {
  title: "Expert translators intelligently matched to fit your needs",
  description:
    "To ensure you receive error-free translations with context-aware precision, we pair your project with professional translators who have focused expertise across your industry, language pairing, deliverable, and use case.",
} as const;

const industriesSolutionsCards: SolutionsCardProps[] = [
  {
    iconId: "icon-global_32",
    title: "Any Language",
    description: "Access translation professionals across 100+ languages.",
    href: "/languages",
    linkLabel: "Explore all languages",
  },
  {
    iconId: "icon-file-text_32",
    title: "Any Industry",
    description:
      "Tap industry specialized translators with subject matter expertise.",
    href: "/industries",
    linkLabel: "Explore all industries",
  },
  {
    iconId: "icon-case_32",
    title: "Any Use case",
    description:
      "Our translators are vetted for the focused experience you need.",
    href: "/use-cases",
    linkLabel: "Explore all use case",
  },
];

export const industriesSolutionsData = {
  ...industriesSolutionsContent,
  cards: industriesSolutionsCards,
};
